<template>
  <div class="multi multi-band-banner" :style="getColor(bannerInfo)" v-if="bannerInfo !== null" v-on-display="{sectionInfo, context: this}">
    <a href="#" @click.prevent="goDetail(bannerInfo)" :style="bgImage(bannerInfo)">{{bannerTitle(bannerInfo)}}</a>
  </div>
</template>

<script>
import _ from 'lodash'
import fp from 'lodash/fp'
import { fetchOnContent } from '@/common/utils/request.common'
import { getCellList, getCellEventObject } from '@/common/utils/gnb.fp'
import { onDisplay } from '@/common/resources/directives'
import { ON_CLICK_CELL } from '@/common/resources/const'
import { bannerLink } from '@/common/utils/common'

export default {
  name: 'TemplateSingleBanner',
  directives: {
    onDisplay
  },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  data () {
    return { bannerInfo: null }
  },
  methods: {
    async setData () {
      const response = await fetchOnContent(this.sectionInfo)
      this.bannerInfo = _.get(getCellList(response), '0', null)
    },
    getColor () {
      return `background-color:${this.sectionInfo.bg_color}`
    },
    getTitle (cell) {
      return _.get(cell, ['title_list', '0', 'text'], '')
    },
    bgImage (cell) {
      return `background-image:url(https://${cell.thumbnail})`
    },
    goDetail (bannerInfo) {
      const { onClick, onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(bannerInfo)
      this.$events.$emit(ON_CLICK_CELL, onClick)
      const url = _.get(onNavigation, 'url', '')
      // .replace(constant.URL_DOMAIN, '')
      // .replace(constant.URL_PROTOCOL_DEEP_LINK, '')
      // .replace('www.wavve.com', '')
      bannerLink(url)
    },
    bannerTitle (bannerInfo) {
      return _.get(bannerInfo, 'title_list.0.text', '') + ' 바로가기'
    }
  },
  created () {
    this.setData()
  }
}
</script>
